import { LayoutResponseType } from '@app-store'
import { ElementType } from '../types/layout.types'
import {
  getEffectiveDisabled,
  getEffectiveDateBound,
  getEffectiveRequired,
} from './formBehavior.utils'
import { triggerFormBehaviorEvaluation } from './formBehaviorTrigger.registry'
import { useFormBehaviorState } from './useFormBehaviorState'

export const getFormBehaviorRuleKey = (element: ElementType): string =>
  element.keyName ??
  element.meta?.field_name ??
  element.meta?.originalKeyName ??
  ''

export const useFormBehaviorFieldOverrides = (
  fullLayout: LayoutResponseType | undefined,
  element: ElementType,
  baseDisabled: boolean,
  layoutRequired?: boolean | null
) => {
  const layoutUid = fullLayout?.uid
  const formBehavior = useFormBehaviorState(layoutUid)
  const ruleKey = getFormBehaviorRuleKey(element)
  const hasFormRules = !!(
    layoutUid && (fullLayout?.layout_data?.meta?.form_rules?.length ?? 0) > 0
  )

  return {
    ruleKey,
    hasFormRules,
    effectiveDisabled: getEffectiveDisabled(
      ruleKey,
      baseDisabled,
      formBehavior.disabledOverrides
    ),
    effectiveRequired: getEffectiveRequired(
      ruleKey,
      layoutRequired,
      formBehavior.requiredOverrides
    ),
    behaviorLookupAllowedIds:
      hasFormRules &&
      Object.prototype.hasOwnProperty.call(
        formBehavior.lookupAllowedIds,
        ruleKey
      )
        ? formBehavior.lookupAllowedIds[ruleKey]
        : undefined,
    behaviorCategoryAllowedIds:
      hasFormRules &&
      Object.prototype.hasOwnProperty.call(
        formBehavior.categoryAllowedIds,
        ruleKey
      )
        ? formBehavior.categoryAllowedIds[ruleKey]
        : undefined,
    effectiveMinDate: getEffectiveDateBound(
      ruleKey,
      '',
      formBehavior.minDateOverrides
    ),
    effectiveMaxDate: getEffectiveDateBound(
      ruleKey,
      '',
      formBehavior.maxDateOverrides
    ),
    triggerFieldChange: () => {
      if (layoutUid && hasFormRules) {
        triggerFormBehaviorEvaluation(layoutUid, 'change', ruleKey)
      }
    },
  }
}
